import { useEffect } from "react";
import { useSelector } from "react-redux";

import { chargesEndpoints } from "../../../api";
import type { RootState } from "../../../redux/reducers/session/state";

// Trustpilot global function type declaration
declare global {
  interface Window {
    tp?: (action: string, data: Record<string, unknown>) => void;
  }
}

const useTrustpilotInvitation = (sendInvitation: boolean | undefined) => {
  const sessionUser = useSelector((state: RootState) => state.sessionState?.user);
  useEffect(() => {
    if (!sessionUser?.trustpilotInvitationSent && !!sendInvitation)
      try {
        window.tp?.("createInvitation", {
          recipientEmail: sessionUser?.email,
          recipientName: sessionUser?.name,
          referenceId: "user_" + sessionUser?.id,
          source: "InvitationScript",
        });
        chargesEndpoints.setMyTrustpilotInvitationSent();
      } catch (e) {
        console.warn("Trustpilot invitation failed", e);
      }
  }, [sendInvitation, sessionUser]);
};

export default useTrustpilotInvitation;
